import "../css/card_design.css"
import UserRegister from "../model/request/UserRegister";
import RegisteredUserResponse from "../model/response/RegisteredUserResponse";
import TopBar from "./TopBar";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import "../css/Nav design.css";




function Accountexist() {
     var navigation = useNavigate();
     var location = useLocation();
     const { accounts } = location.state || {};
     const { userObject } = location.state || {};
     useEffect(() => {
          if (accounts == null || userObject == null) {
               navigation('/');
          }
     }, [accounts, userObject, navigation]);
     if (!accounts || !userObject) {
          return null; // render nothing briefly
     }
     var userAccounts = Object.setPrototypeOf(accounts, RegisteredUserResponse.prototype);
     var userRegister = Object.setPrototypeOf(userObject, UserRegister.prototype);


     console.log("Response:", userObject);

     function continueNewAccount() {
          navigation('/Place_screen', { state: { userRegister } });

     }
     return (
          <div className="fullview">
               <div className="register-column">
                    <TopBar />

                    <div className="card_design1">
                         <h3>Account already exists</h3>
                         <label>You already have a profile registered with same mobile number <b>+91 {userRegister.mobile_Number}</b></label>
                         {userAccounts.registerList.map((item) => (
                              <div className="inside_card" style={{ marginTop: "10px" }} key={item.user_Id}>
                                   <div>
                                        <img src="https://market-resized.envatousercontent.com/photodune.net/EVA/TRX/b4/06/80/53/a4/v1_E11/E1139EUA.jpeg?auto=format&q=94&mark=https%3A%2F%2Fassets.market-storefront.envato-static.com%2Fwatermarks%2Fphoto-260724.png&opacity=0.2&cf_fit=contain&w=590&h=884&s=ade8cb2e5494eaec7be4aec07992678588d92aac7b5fa40a4c5398593972fa6a" />
                                   </div>
                                   <div className="second_row">
                                        <label><b>{item.user_Name}</b></label><br />
                                        <label>E9876543</label><br />
                                        <span>Login to this profile </span>
                                   </div>

                              </div>
                         ))}

                         <button className="account_btn" onClick={continueNewAccount}>Continue creating new account</button>

                    </div>
               </div>
          </div>

     );
}
export default Accountexist;